import { render, staticRenderFns } from "./Greetinglayout.vue?vue&type=template&id=4165b264&"
import script from "./Greetinglayout.vue?vue&type=script&lang=js&"
export * from "./Greetinglayout.vue?vue&type=script&lang=js&"
import style0 from "./Greetinglayout.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VApp } from 'vuetify/lib/components/VApp';
import { VDialog } from 'vuetify/lib/components/VDialog';
installComponents(component, {VApp,VDialog})
